exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tabs .pull-to-refresh-content{top:0;height:100%}.tabs .pull-to-refresh-content:refreshing{top:2.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7964dcbc","scoped":false,"hasInlineConfig":false}!./node_modules/_less-loader@4.0.5@less-loader/dist/cjs.js!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/tab/Tab.vue
// module id = CEO8
// module chunks = 1